(function($) {


    $(".sidebar-nav-toggle").on("mousedown touchend", function (e) {
        e.preventDefault();
        $(this).children("i").toggleClass('fa-bars').toggleClass('fa-xmark');
        $(".sidebar-navigation .navigation").slideToggle().toggleClass("open");
        

        $(".sidebar-navigation .navigation .menu .menu-item").each(function () {
            let h = $(this).height();
            if($(window).width() < 992) {
               if(h > 121){ $(this).addClass('three-lines'); } else if(h > 61){ $(this).addClass('two-lines'); }
                console.log('hello');
            } 
        });

        return false;
    });

    $(window).on("resize", function () {
        let $nav = $(".sidebar-navigation .navigation");
        if($(window).width() > 992) {
            $nav.css("display", "block");
        }
    });

    $(".sidebar-navigation .navigation .menu .menu-item-has-children").each(function () {
        $(this).children("a").after('<div class="toggle"><i class="fa-light fa-chevron-down"></i></div>');
    });

    $(".sidebar-navigation .navigation .menu .menu-item").each(function () {
        var h = $(this).height();
        if(h > 160){ $(this).addClass('three-lines'); } else if(h > 101){ $(this).addClass('two-lines'); }
    });

    $(".sidebar-navigation .navigation .menu .menu-item-has-children .toggle").on("click", function () {
        $(this).parent().toggleClass('active');
        $(this).next(".sub-menu").slideToggle();
    });

    if($(".sub-menu li").hasClass('current_page_item')){
        var menuItem = $(".sub-menu li.current_page_item");
        $(menuItem).parent().parent().addClass('active');
        $(menuItem).parent(".sub-menu").slideToggle();
    }

})( jQuery );